import React from 'react';
import { twMerge } from 'tailwind-merge';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
  prefix?: string;
}
export function Input({
  label,
  error,
  hint,
  prefix,
  className,
  id,
  ...props
}: InputProps) {
  const inputId = id || Math.random().toString(36).substring(7);
  return <div className="w-full" data-id="element-43">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-44">
          {label}
        </label>}
      <div className="relative" data-id="element-45">
        {prefix && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-46">
            <span className="text-gray-500 sm:text-sm" data-id="element-47">{prefix}</span>
          </div>}
        <input id={inputId} className={twMerge('block w-full rounded-xl border-gray-200 shadow-sm focus:border-gray-900 focus:ring-gray-900 sm:text-sm transition-colors', prefix && 'pl-7', error && 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-500 focus:ring-red-500', className)} {...props} data-id="element-48" />
      </div>
      {error && <p className="mt-1.5 text-xs text-red-600" data-id="element-49">{error}</p>}
      {hint && !error && <p className="mt-1.5 text-xs text-gray-500" data-id="element-50">{hint}</p>}
    </div>;
}
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  hint?: string;
}
export function Textarea({
  label,
  error,
  hint,
  className,
  id,
  ...props
}: TextareaProps) {
  const inputId = id || Math.random().toString(36).substring(7);
  return <div className="w-full" data-id="element-51">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-52">
          {label}
        </label>}
      <textarea id={inputId} className={twMerge('block w-full rounded-xl border-gray-200 shadow-sm focus:border-gray-900 focus:ring-gray-900 sm:text-sm transition-colors resize-y', error && 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-500 focus:ring-red-500', className)} {...props} data-id="element-53" />
      {error && <p className="mt-1.5 text-xs text-red-600" data-id="element-54">{error}</p>}
      {hint && !error && <p className="mt-1.5 text-xs text-gray-500" data-id="element-55">{hint}</p>}
    </div>;
}
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  hint?: string;
  options: {
    value: string;
    label: string;
  }[];
}
export function Select({
  label,
  error,
  hint,
  options,
  className,
  id,
  ...props
}: SelectProps) {
  const inputId = id || Math.random().toString(36).substring(7);
  return <div className="w-full" data-id="element-56">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-57">
          {label}
        </label>}
      <select id={inputId} className={twMerge('block w-full rounded-xl border-gray-200 shadow-sm focus:border-gray-900 focus:ring-gray-900 sm:text-sm transition-colors', error && 'border-red-300 text-red-900 focus:border-red-500 focus:ring-red-500', className)} {...props} data-id="element-58">
        {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-59">
            {opt.label}
          </option>)}
      </select>
      {error && <p className="mt-1.5 text-xs text-red-600" data-id="element-60">{error}</p>}
      {hint && !error && <p className="mt-1.5 text-xs text-gray-500" data-id="element-61">{hint}</p>}
    </div>;
}